module.exports = __webpack_public_path__ + "img/digital-pathology.044768e4.png";